(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lamoreco-custom-reviews"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.querySelector('.lc-design-dialog');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    document.querySelectorAll('[data-lc-design-open]').forEach(link => {
      link.addEventListener('click', event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        const image = dialog.querySelector('img');
        image.src = link.href;
        image.alt = link.querySelector('img').alt;
        dialog.showModal();
      });
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    });
  })();
  (() => {
    document.querySelectorAll('[data-lc-review-carousel]').forEach(carousel => {
      if (carousel.dataset.ready) return;
      const slides = Array.from(carousel.querySelectorAll('[data-lc-review-slide]'));
      if (slides.length < 2) return;
      const track = carousel.querySelector('.lc-review-slides');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      let index = 0;
      let paused = reduced.matches;
      let visible = false;
      let timer;
      function schedule() {
        clearTimeout(timer);
        if (!paused && visible && !document.hidden) timer = setTimeout(() => { show(index + 1); schedule(); }, 5000);
      }
      function setPaused(value) {
        paused = value;
        track.setAttribute('aria-label', paused ? track.dataset.play : track.dataset.pause);
        track.setAttribute('aria-pressed', String(paused));
        track.setAttribute('aria-live', paused ? 'polite' : 'off');
        schedule();
      }
      function show(next) {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, number) => {
          const active = number === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
      }
      carousel.dataset.ready = 'true';
      carousel.classList.add('is-ready');
      track.tabIndex = 0;
      track.setAttribute('role', 'button');
      show(0);
      setPaused(paused);
      track.addEventListener('click', () => setPaused(!paused));
      track.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          setPaused(!paused);
        }
      });
      document.addEventListener('visibilitychange', schedule);
      reduced.addEventListener('change', event => { if (event.matches) setPaused(true); });
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); }, { threshold: .35 });
      observer.observe(carousel);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
